import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import $utils from '@/assets/js/utils'
import VueCookie from 'vue-cookie'
import liveOperate from './live800Operate'
Vue.use(VueRouter);
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
	return routerPush.call(this, location).catch((error) => error);
};
const routes = [{
		path: '/',
		name: 'home',
		redirect: '/personal/my-volunteer', // 添加重定向到子路由
		meta: {
			title: "赢在高考",
			footerType: 0,
		},
		component: () => import('@/views/home/home.vue')
	},
	// 选科指南
	{
		path: '/subject-guide/my-subject-scheme',
		name: 'mySubjectScheme',
		meta: {
			title: "我的选科方案",
			footerType: 1,
		},
		component: () => import('@/views/subject-guide/my-subject-scheme.vue')
	},
	{
		path: '/subject-guide/add-major',
		name: 'addMajor',
		meta: {
			title: "由专业选科目",
			footerType: 1,
		},
		component: () => import('@/views/subject-guide/add-major.vue')
	},
	{
		path: '/subject-guide/subject-select-major',
		name: 'subjectSelectMajor',
		meta: {
			title: "由科目选专业",
			footerType: 1,
		},
		component: () => import('@/views/subject-guide/subject-select-major.vue')
	},
	// 填报指南
	{
		path: '/fill-guide/simulation',
		name: 'simulation',
		meta: {
			title: "模拟志愿填报",
			is_forbidden_right: true,
			footerType: 1,
		},
		component: () => import('@/views/fill-guide/simulation/simulation.vue')
	},
	{
		path: '/fill-guide/simulation-details/:id',
		name: 'simulationDetails',
		meta: {
			title: "志愿详情",
			footerType: 1,
			is_forbidden_right: true,
		},
		component: () => import('@/views/fill-guide/simulation/simulation-details.vue')
	},
	{
		path: '/fill-guide/Intelligence',
		name: 'Intelligence',
		meta: {
			title: "智能填报",
			is_forbidden_right: true,
			footerType: 1,
		},
		component: () => import('@/views/fill-guide/Intelligence/Intelligence.vue')
	},
	{
		path: '/fill-guide/school-data',
		name: 'schoolData',
		meta: {
			title: "院校数据查询",
			footerType: 1,
			is_forbidden_right: true,
		},
		component: () => import('@/views/fill-guide/school-data/school-data.vue')
	},
	{
		path: '/fill-guide/major-data',
		name: 'majorData',
		meta: {
			title: "专业数据查询",
			footerType: 1,
			is_forbidden_right: true,
		},
		component: () => import('@/views/fill-guide/major-data/major-data.vue')
	},
	{
		path: '/fill-guide/admission-plan',
		name: 'admissionPlan',
		meta: {
			title: "招生计划查询",
			footerType: 1,
			is_forbidden_right: true,
		},
		component: () => import('@/views/fill-guide/admission-plan/admission-plan.vue')
	},
	{
		path: '/fill-guide/target-school',
		name: 'targetSchool',
		meta: {
			title: "目标院校对比",
			footerType: 1,
			is_forbidden_right: true,
		},
		component: () => import('@/views/fill-guide/target-school/target-school.vue')
	},
	{
		path: '/fill-guide/score-level',
		name: 'scoreLevel',
		meta: {
			title: "分数位次查询",
			footerType: 1,
			is_forbidden_right: true,
		},
		component: () => import('@/views/fill-guide/score-level/score-level.vue')
	},
	{
		path: '/fill-guide/Batch-line',
		name: 'BatchLine',
		meta: {
			title: "批次线查询",
			footerType: 1,
			is_forbidden_right: true,
		},
		component: () => import('@/views/fill-guide/Batch-line/Batch-line.vue')
	},
	{
		path: '/fill-guide/points-query',
		name: 'pointsQuery',
		meta: {
			title: "出分查询",
			footerType: 1,
			is_forbidden_right: true,
		},
		component: () => import('@/views/fill-guide/Batch-line/points-query.vue')
	},
	// 个人中心
	{
		path: '/personal',
		name: 'personal',
		meta: {
			title: "用户中心",
			footerType: 1,
		},
		component: () => import('@/views/personal/index.vue'),
		children: [{
				path: '/personal/my-volunteer',
				name: 'myVolunteer',
				meta: {
					title: "我的志愿表",
					footerType: 1,
				},
				component: () => import('@/views/personal/my-volunteer.vue')
			}, {
				path: '/personal/my-collect',
				name: 'myCollect',
				meta: {
					title: "我的收藏",
					footerType: 1,
				},
				component: () => import('@/views/personal/my-collect.vue')
			},
			{
				path: '/personal/my-scheme',
				name: 'myScheme',
				meta: {
					title: "我的方案",
					footerType: 1,
				},
				component: () => import('@/views/personal/my-scheme.vue')
			},
			{
				path: '/personal/safe-set',
				name: 'safeSet',
				meta: {
					title: "安全设置",
					footerType: 1,
				},
				component: () => import('@/views/personal/safe-set.vue')
			},
			{
				path: '/personal/message-center',
				name: 'messageCenter',
				meta: {
					title: "消息中心",
					footerType: 1,
				},
				component: () => import('@/views/personal/message-center.vue')
			},
			{
				path: '/personal/appraisal-result',
				name: 'appraisalResult',
				meta: {
					title: "我的测评结果",
					footerType: 1,
				},
				component: () => import('@/views/personal/appraisal-result.vue')
			},
			{
				path: '/personal/my-order/page',
				name: 'myOrderPage',
				meta: {
					title: "我的订单",
					footerType: 1,
				},
				component: () => import('@/views/personal/my-order/page.vue')
			},
			{
				path: '/personal/my-order/detail/:id',
				name: 'myOrderDetail',
				meta: {
					title: "订单详情",
					footerType: 1,
				},
				component: () => import('@/views/personal/my-order/detail.vue')
			},
		]
	},
	{
		path: '/personal/retrieve-password',
		name: 'retrievePassword',
		meta: {
			title: "找回密码",
			footerType: 1,
		},
		component: () => import('@/views/personal/retrieve-password.vue')
	},
	{
		path: '/personal/retrieve-phone',
		name: 'retrievePhone',
		meta: {
			title: "更换手机号",
			footerType: 1,
		},
		component: () => import('@/views/personal/retrieve-phone.vue')
	},
	{
		path: '/personal/register',
		name: 'register',
		meta: {
			title: "新用户注册",
			footerType: 1,
		},
		component: () => import('@/views/personal/register.vue')
	},
	{
		path: '/personal/success-page/:type',
		name: 'successPage',
		meta: {
			title: "",
			footerType: 1,
		},
		component: () => import('@/views/personal/success-page.vue')
	},
	{
		path: '/personal/user-agreement',
		name: 'userAgreement',
		meta: {
			title: "用户服务协议",
			footerType: 1,
		},
		component: () => import('@/views/personal/user-agreement.vue')
	},
	{
		path: '/personal/edit-data',
		name: 'editData',
		meta: {
			title: "修改资料",
			footerType: 1,
		},
		component: () => import('@/views/personal/edit-data.vue')
	},
	{
		path: '/login',
		name: 'loginPage',
		meta: {
			title: "登录",
			footerType: 1,
		},
		component: () => import('@/views/personal/loginPage.vue')
	},
	{
		path: '/buy-card',
		name: 'buyCard',
		meta: {
			title: "购买凌云卡",
			footerType: 1,
		},
		component: () => import('@/views/buy-card/index.vue')
	},
	{
		path: '/buy-card/pay',
		name: 'buyCardPay',
		meta: {
			title: "购买凌云卡",
			footerType: 1,
		},
		component: () => import('@/views/buy-card/pay.vue')
	},
	{
		path: '/buy-card/pay-success/:type',
		name: 'buyCardPaySuccess',
		meta: {
			title: "支付成功",
			footerType: 1,
		},
		component: () => import('@/views/buy-card/pay-success.vue')
	},
	{
		path: '/buy-card/pay-fail',
		name: 'buyCardPayFail',
		meta: {
			title: "支付失败",
			footerType: 1,
		},
		component: () => import('@/views/buy-card/pay-fail.vue')
	},
	{
		path: '/buy-card/conversion',
		name: 'buyCardConversion',
		meta: {
			title: "凌云卡兑换",
			footerType: 1,
		},
		component: () => import('@/views/buy-card/conversion.vue')
	},
	{
		path: '/buy-card/give',
		name: 'buyCardGive',
		meta: {
			title: "凌云卡赠送",
			footerType: 1,
		},
		component: () => import('@/views/buy-card/give.vue')
	},
	{
		path: '/buy-card/rule/:type',
		name: 'buyCardPayRule',
		meta: {
			title: "凌云卡兑换规则",
			footerType: 1,
		},
		component: () => import('@/views/buy-card/rule.vue')
	},
	{
		path: '/miss-data/:id',
		name: 'missData',
		meta: {
			title: "缺少数据",
			footerType: 1,
		},
		component: () => import('@/views/miss-data/index.vue')
	},
]
let timer = null
// 创建路由实例
const router = new VueRouter({
	routes: routes,
	mode: 'history',
	base: '/peer',
	scrollBehavior(to, from, savedPosition) {
		// 解决vue页面之间跳转，页面不是在顶部的问题
		if (['previewInformationSon'].indexOf(from.name) > -1) {
			return savedPosition
		} else {
			return {
				x: 0,
				y: 0
			};
		}
	},
});

router.afterEach((to, from) => {
	store.commit("setPreRouter", from);
	store.commit("setPreType", to.meta.footerType);
	// if (to.meta.title) {
	// 	let title = to.meta.title;
	// 	document.title = title;
	// 	store.commit("setPageTitle", title);
	// }
	if (to.meta.is_forbidden_right) {
		document.onselectstart = new Function("event.returnValue=false");
		document.oncontextmenu = new Function("event.returnValue=false");
	} else {
		document.onselectstart = new Function("event.returnValue=true");
		document.oncontextmenu = new Function("event.returnValue=true");
	}

});
router.beforeEach((to, form, next) => {

	liveOperate(to)

	let data = VueCookie.get('loginInfo') ? JSON.parse(VueCookie.get('loginInfo')) : {}
	if (Object.keys(data).length) {
		// let cur_time = new Date().getTime()
		// let expiration_time = new Date(data.expiration).getTime()
		// let subtract_time = parseInt((expiration_time - cur_time) / 1000)
		// subtract_time = subtract_time - 60 > 0 ? subtract_time - 60 : 0
		// console.log('subtract_time', subtract_time);
		// clearTimeout(timer)
		// timer = setTimeout(() => {
		// 	$utils.getRefreshToken()
		// }, subtract_time * 1000)

		let cur_time = new Date().getTime()
		let expiration_time = VueCookie.get("loginTime")
		if (expiration_time) {
			console.log(cur_time, "cur_time")
			console.log(expiration_time, "expiration_time")
			console.log(cur_time - expiration_time - 82800000, "cur_time - expiration_time")
			if (cur_time - expiration_time > 82800000) {
				setTimeout(() => {
					$utils.getRefreshToken()
				}, 1000)
			}
		}
	}
	// 拦截需要提示的路由name，whitePathName：这里相当于一个白名单，用于判断哪些页面需要使用该功能
	const whitePathName = ['simulation'];
	if (!whitePathName.includes(form.name)) return next();
	console.log(window.sessionStorage.getItem('changeSteps'), "window.sessionStorage.getItem('changeSteps')")
	if (window.sessionStorage.getItem('changeSteps') == 4) {
		Vue.prototype.$confirm('现在离开可能无法保存当前志愿表信息，建议您先保存志愿表再离开。确定离开当前页面吗？', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(() => {
			next();
			window.sessionStorage.setItem('changeSteps', 1);
		}).catch(() => {
			next(false);
		});
	} else {
		next()
	}
	// next()
})
export default router;
